<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-6">
      <app-text-input
        controlName="healthcareProviderId"
        placeholder="{{ hpIdMaskConfig.mask }}"
        [maskConfig]="hpIdMaskConfig"
      ></app-text-input>
    </div>
    <div class="col-6">
      <app-generic-input approvedNameCharacters controlName="providerName"></app-generic-input>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <app-generic-input controlName="nationalProviderIdentifier"></app-generic-input>
    </div>
    <div class="col-6">
      <app-generic-input controlName="licenseNumber"></app-generic-input>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <app-disabled-input
        labelOverride="Provider Type"
        controlName="healthcareProviderProfession"
      ></app-disabled-input>
    </div>
  </div>
</form>
